// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DeviceSessionIPLine__container-b25921 {
  --meta-block-actions-background: var(--base-10);
}

.DeviceSessionIPLine__ip-address-af4db1 {
  color: var(--brand-primary-40);
}`, "",{"version":3,"sources":["webpack://./../../packages/components/src/Device/DeviceDetails/DeviceSessionIPLine/DeviceSessionIPLine.styles.m.css"],"names":[],"mappings":"AAAA;EACE,+CAAA;AACF;;AAEA;EACE,8BAAA;AACF","sourcesContent":[".container {\n  --meta-block-actions-background: var(--base-10);\n}\n\n.ip-address {\n  color: var(--brand-primary-40);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `DeviceSessionIPLine__container-b25921`,
	"ip-address": `DeviceSessionIPLine__ip-address-af4db1`,
	"ipAddress": `DeviceSessionIPLine__ip-address-af4db1`
};
module.exports = ___CSS_LOADER_EXPORT___;
